import {
  FormControl,
  SelectChangeEvent,
  Box,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IDropdownProps {
  options: Array<{ value: string; label: string }>;
  onChange: (_event: SelectChangeEvent<unknown>) => void;
  value: string;
  name?: string;
  onBlur?: (_event: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  label?: string;
  required?: boolean;
  row?: boolean;
}

function StyledRadioGroup({
  options,
  onChange,
  value,
  name,
  onBlur,
  error,
  label,
  required,
  row,
}: IDropdownProps) {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <FormControl fullWidth required={required}>
        <FormLabel id="demo-controlled-radio-buttons-group">{label}</FormLabel>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          row={row}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={
                <Radio
                  sx={{
                    color: '#85B5C9',
                    '&.Mui-checked': {
                      color: '#85B5C9',
                    },
                  }}
                />
              }
              label={t(option.label)}
            />
          ))}
        </RadioGroup>
      </FormControl>
      {error && (
        <FormHelperText sx={{ color: 'red', marginTop: '-2px' }}>{t(error)}</FormHelperText>
      )}
    </Box>
  );
}

export default StyledRadioGroup;
